import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessageService } from 'primeng/api';
import { ESignService } from 'src/app/services/e-sign.service';
import { TableColumn } from 'src/app/shared-components/data-table/data-table.component';

@Component({
  selector: 'app-share-sign-link-details',
  templateUrl: './share-sign-link-details.component.html',
  styleUrls: ['./share-sign-link-details.component.scss'],
  standalone: false,
})
export class ShareSignLinkDetailsComponent implements OnInit {
  readonly columns: TableColumn[] = [
    { field: 'order_reference_id', header: 'Order Reference', width: '10%' },
    { field: 'created_at', header: 'Created On', width: '10%' },
    {
      field: 'sign_method',
      header: 'Method',
      width: '10%',
      cellClass: 'badge',
      cellStyle: { 'background-color': '#f6f8fb', color: '#555', padding: '5px 10px', 'border-radius': '4px' },
    },
    { field: 'doqfy_sign_url', header: 'Sign Link', width: '45%' },
  ];

  pageNo: number = 0;
  rowsPerPage: number = 10;
  totalRecords: number = 0;
  orders: any[] = [];
  signerDetails: any = { name: '---', email: '---', contact: '---' };

  constructor(
    private spinner: NgxSpinnerService,
    private esignService: ESignService,
    private router: Router,
    private messageService: MessageService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    if (!this.esignService.verifiedContact) {
      this.router.navigate(['/public-sign-link']);
      return;
    }
    this.fetchData();
  }

  fetchData(pageNumber: number = 1) {
    this.spinner.show();
    const contact = this.esignService.verifiedContact;
    const isEmail = this.esignService.isVerifiedEmail;

    this.esignService
      .getPublicEsignUrls(contact, isEmail, pageNumber, this.rowsPerPage)
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          if (res && res.content) {
            this.orders = res.content;
            if (this.orders.length > 0) {
              this.signerDetails = {
                name: this.orders[0].name,
                email: this.orders[0].email,
                contact: this.orders[0].contact,
              };
            }
            this.totalRecords = res.pagination?.total_records || 0;

            if (
              this.totalRecords === 1 &&
              this.orders.length > 0 &&
              this.orders[0].doqfy_sign_url
            ) {
              setTimeout(() => {
                window.open(this.orders[0].doqfy_sign_url, '_blank');
              }, 600);
            }
          } else {
            this.orders = [];
            this.totalRecords = 0;
          }
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.spinner.hide();
          this.orders = [];
          this.cdr.detectChanges();
          console.error('Failed to fetch links:', err);
        },
      });
  }

  onPageChange(event: any) {
    this.pageNo = event.first;
    this.rowsPerPage = event.rows;
    const apiPageNumber = Math.floor(this.pageNo / this.rowsPerPage) + 1;
    this.fetchData(apiPageNumber);
  }

  onRowsPerPageChange(newRows: any) {
    this.rowsPerPage = newRows;
    this.pageNo = 0;
    this.fetchData(1);
  }

  copyLink(link: string) {
    if (!link) return;
    navigator.clipboard
      .writeText(link)
      .then(() => {
        this.messageService.add({
          severity: 'success',
          summary: 'Copied',
          detail: 'Link copied to clipboard',
          life: 2000,
        });
      })
      .catch((err) => {
        console.error('Could not copy text: ', err);
      });
  }

  back() {
    this.router.navigate(['/public-sign-link']);
  }

}
